import styled from 'styled-components';

export const Tooltip = styled.div`
  display: none;
  background: white;
  border-radius: 3px;
  position: absolute;
  left: -6px;
  top: -50px;
  transform: translateX(-50%);
  cursor: pointer;
  box-shadow: 0px 0px 6px 0px rgba(122, 121, 122, 0.2);
  width: 130px;
  z-index: 9;
  &:hover {
    display: none !important;
  }
  .arrow {
    width: 0;
    height: 0;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-top: 15px solid white;
    margin-left: -10px;
    top: 100%;
    left: 70%;
    position: absolute;
    filter: drop-shadow(0px 3px 2px rgba(0, 0, 0, 0.1));
  }
  .tooltipTxt {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 12px;
    .seatNum {
      flex: 1;
      border-right: 1px solid #e1e1e1;
      padding: 1rem;
      text-align: center;
      color: #777;
    }
    .seatPrice {
      flex: 1;
      padding: 1rem;
      text-align: center;
      color: black;
    }
  }
`;
export const BusSleeper = styled.div`
  position: absolute;
  display: flex;
  width: 40px;
  height: 18px;
  cursor: pointer;
  left: ${props => props.left};
  top: ${props => props.top};
  &:hover ${Tooltip} {
    display: block;
  }
`;
export const BusSeat = styled.div`
  position: absolute;
  display: flex;
  width: 20px;
  height: 20px;
  cursor: pointer;
  left: ${props => props.left};
  top: ${props => props.top};
  ${Tooltip} {
    left: -22px;
  }
  &:hover ${Tooltip} {
    display: block;
  }
`;
